<template>
  <section class="bg-indonesia">
    <div class="max-w-screen-xl px-4 py-8 mx-auto lg:px-6 sm:py-16 lg:py-12">


      <div class="max-w-5xl mx-auto mt-8 lg:mt-16">

        <nuxt-img class="w-full rounded-lg shadow-lg"
                  src="assets/images/indonesia-3.jpg"
                  width="1024"
                  height="482"
                  loading="lazy"
                  format="webp"
                  sizes="xs:330px sm:440px md:900px lg:1024px xl:1024px 2xl:1024px"
                  alt="cajamarca photo"/>

      </div>

      <div class="grid grid-cols-1 gap-8 mt-8 lg:gap-16 lg:grid-cols-2 lg:mt-16">
        <div>
          <div>
            <h3 class="font-extrabold h3">
              The Art of Small-Scale Farming: Experience the Charm of Intimate Coffee Production, Where Precision and
              Passion Collide

            </h3>
            <p class="pt-4 mt-2 h4">
              Nestled within the captivating landscape of Cajamarca, the smallholder farms that cultivate these
              exceptional micro-lot coffees are truly unique.

            </p>

            <p class="pt-4 mt-2 h4">
              Each farm spans a mere 2-3 hectares, roughly equivalent to 5-7.4 acres, or about the size of a few soccer fields. This small scale allows for a level of precision and personal touch that goes into every step of the coffee production process.
            </p>

          </div>


        </div>

        <div class="space-y-8">
          <ul class="">



            <li class="flex mt-4 space-x-3"><!-- Icon -->
              <span class="h4  -mt-0.5">
              These intimate farms enable the coffee growers to tend to each plant with the utmost care, a testament to the dedication and artisanal craftsmanship that simply cannot be replicated in larger operations.

              </span>
            </li>

            <li class="flex mt-4 space-x-3"><!-- Icon -->
              <span class="h4  -mt-0.5">
             It's within these cozy corners of the Peruvian highlands that the magic of Rony Lavan's traceable microlot coffee comes to life, combining the perfect blend of environmental conditions, traditional farming practices, and heartfelt passion to create an unparalleled coffee experience.

              </span>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>

defineBuilderComponent({
    friendlyName: 'Content_Section_2',
    ignored: true
})

</script>